import { IAppState } from 'models/store.model'

import { getPurchaseCommonEventParams } from 'modules/payment/helpers/getPurchaseCommonEventParams'

export const getPurchaseStartedEventParams = (state: IAppState) => {
  const {
    email,
    productId,
    price,
    trialPriceId,
    currency,
    screenName,
    stripeAccountName,
    stripeAccountId,
    stripePriceId,
    isPersonalDataAllowed,
  } = getPurchaseCommonEventParams(state)

  return {
    email,
    productId: trialPriceId ? productId : stripePriceId,
    priceDetails: {
      price,
      trial: !!trialPriceId,
      currency,
    },
    screenName,
    stripeAccountName,
    stripeAccountId,
    isPersonalDataAllowed,
  }
}
